import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	setAllPlayers: [],
	allPlayersRefresh: 0,
	onlineUsers: [],
	allPlayerBet: [],
	account: [],
};

export const allPlayersSlice = createSlice({
	name: "allPlayers",
	initialState,
	reducers: {
		setAllPlayers: (state, action) => {
			state.setAllPlayers = action.payload;
		},
		allPlayersRefresh: (state, action) => {
			state.allPlayersRefresh = action.payload;
		},
		onlineUsers: (state, action) => {
			state.onlineUsers = action.payload;
		},
		allPlayerBet: (state, action) => {
			state.allPlayerBet = action.payload;
		},
		account: (state, action) => {
			state.account = action.payload;
		},
	},
});

// Export actions
export const { setAllPlayers, allPlayersRefresh, onlineUsers, allPlayerBet, account } = allPlayersSlice.actions;

// Export reducer
export default allPlayersSlice.reducer;
